/*
 * ====================================================================
 * Grow Template
 * @package  Grow Template
 * @author   GrowGroup.Inc <info@grow-group.jp>
 * @license  MIT Licence
 * ====================================================================
 */

import $ from "./app/jquery-shim";

(function ($) {
  var growApp = function () {

  };

  /************************
   * please insert your code
   *************************/
  // growApp.prototype.myCode = function () {
  //
  // }

  growApp.prototype.enterAnimation = function () {

    var $main = document.querySelector(".c-main-visual");
    var $mainImage = document.querySelector(".c-main-visual__image");
    var $main01 = document.querySelector(".c-main-visual__image.is-01");
    var $main02 = document.querySelector(".c-main-visual__image.is-02");
    var $main03 = document.querySelector(".c-main-visual__image.is-03");
    var $mainText = document.querySelector(".c-main-visual__inner");

    var win = $(window).innerWidth();
    if (win < 750) {
      $main.classList.add('is-animated');
      return false
    }

    function changeClass(el, className, time) {
      return new Promise(function (resolve, reject) {
        setTimeout(function () {
          el.classList.add(className);
          resolve(className);
        }, time);
      });
    }

    var loaderFunction = function() {

      if ($mainImage) {
        changeClass($main01, "is-visible", 500).then(function () {
          changeClass($main02, "is-visible", 500).then(function () {
            changeClass($main03, "is-visible", 500).then(function () {
              changeClass($mainText, "is-visible", 1000).then(function () {
              });
            });
          });
        });
      }
    };

    // first entry only
    if (!sessionStorage.getItem('loading')) {
      sessionStorage.setItem('loading', true);
      loaderFunction();
    } else {
      // $main.classList.add('is-animated');
      loaderFunction();
    }

  };

  $(function () {
    var app = new growApp();
    app.enterAnimation();
  });
})(jQuery);
